import jwt_decode from "jwt-decode";

export const COGNITO_ACCESS_TOKEN_KEY = "cognitoAccessToken";
export const COGNITO_USER_KEY = "cognitoUser";

export const SSCIAM_ACCESS_TOKEN_KEY = "ssciamAccessToken";
export const SSCIAM_USER_KEY = "ssciamUser";

export const DOUBLE_AUTH_KEY = "enableDoubleAuth";

export const OLD_TOKEN_KEY = "accessToken";

const setAccessToken = (accessToken, username) => {
  window.localStorage.setItem(OLD_TOKEN_KEY, accessToken || "");
  window.localStorage.setItem("cognitoUser", username || "");
};

const getAccessToken = () => {
  return window.localStorage.getItem(OLD_TOKEN_KEY);
};

const hasValidAccessToken = () => {
  const token = window.localStorage.getItem(OLD_TOKEN_KEY);

  if (!token || token.length <= 10) return false;

  try {
    const decodedToken = jwt_decode(token);
    const currentDate = new Date();
    const expired = decodedToken.exp * 1000 < currentDate.getTime();
    return !expired;
  } catch (error) {
    console.error(`Error decoding token (${OLD_TOKEN_KEY}):`, error);
    return false;
  }
};

export const loggedInUserHasScope = (scope) => {
  const accessToken = window.localStorage.getItem(OLD_TOKEN_KEY);
  const decodedToken = jwt_decode(accessToken);
  const scopes = decodedToken?.scope?.split(" ");
  return scopes?.includes(scope) ?? false;
};

// ------------ new methods for double tokens ------------

export const setCognitoTokens = (accessToken, username) => {
  const doubleAuth = doubleAuthEnabled();
  if (!doubleAuth) {
    setAccessToken(accessToken, username);
    return;
  }

  window.localStorage.setItem(COGNITO_ACCESS_TOKEN_KEY, accessToken || "");

  if (username) {
    window.localStorage.setItem(COGNITO_USER_KEY, username);
  } else {
    window.localStorage.removeItem(COGNITO_USER_KEY);
  }
};

export const clearCognitoTokens = () => {
  window.localStorage.removeItem(COGNITO_ACCESS_TOKEN_KEY);
  window.localStorage.removeItem(COGNITO_USER_KEY);
};

export const clearSscIamTokens = () => {
  window.localStorage.removeItem(SSCIAM_ACCESS_TOKEN_KEY);
  window.localStorage.removeItem(SSCIAM_USER_KEY);
};

export const setSscIamTokens = (accessToken, username) => {
  const doubleAuth = doubleAuthEnabled();
  if (!doubleAuth) {
    setAccessToken(accessToken, username);
    return;
  }

  window.localStorage.setItem(SSCIAM_ACCESS_TOKEN_KEY, accessToken || "");

  if (username) {
    window.localStorage.setItem(SSCIAM_USER_KEY, username);
  } else {
    window.localStorage.removeItem(SSCIAM_USER_KEY);
  }
};

export const ssciamIsEnabled = () => {
  return window.localStorage.getItem("enableSscIam");
};

export const hasValidCognitoToken = () => {
  const token = window.localStorage.getItem(COGNITO_ACCESS_TOKEN_KEY);

  if (!token || token.length <= 10) return false;

  try {
    const decodedToken = jwt_decode(token);
    const currentDate = new Date();
    const expired = decodedToken.exp * 1000 < currentDate.getTime();
    if (expired) {
      clearCognitoTokens();
    }
    return !expired;
  } catch (error) {
    console.error(`Error decoding token (${COGNITO_ACCESS_TOKEN_KEY}):`, error);
    return false;
  }
};

export const hasValidSsciamToken = () => {
  const token = window.localStorage.getItem(SSCIAM_ACCESS_TOKEN_KEY);

  if (!token || token.length <= 10) return false;

  try {
    const decodedToken = jwt_decode(token);
    const currentDate = new Date();
    const expired = decodedToken.exp * 1000 < currentDate.getTime();
    if (expired) {
      clearSscIamTokens();
    }
    return !expired;
  } catch (error) {
    console.error(`Error decoding token (${SSCIAM_ACCESS_TOKEN_KEY}):`, error);
    return false;
  }
};

export const hasAnyValidToken = () => {
  const doubleAuth = doubleAuthEnabled();
  if (!doubleAuth) {
    return hasValidAccessToken();
  }

  const isSsciam = ssciamIsEnabled();
  const isValid = isSsciam ? hasValidSsciamToken() : hasValidCognitoToken();
  return isValid;
};

export const getAnyAccessToken = () => {
  const doubleAuth = doubleAuthEnabled();
  if (!doubleAuth) {
    return getAccessToken();
  }

  const isSsciam = ssciamIsEnabled();
  const token = isSsciam
    ? window.localStorage.getItem(SSCIAM_ACCESS_TOKEN_KEY)
    : window.localStorage.getItem(COGNITO_ACCESS_TOKEN_KEY);
  return token;
};

export const getTokenExpiration = (storageKey) => {
  try {
    const token = window.localStorage.getItem(storageKey);
    if (!token || token.length <= 10) {
      return null;
    }
    const decoded = jwt_decode(token);
    return decoded.exp * 1000; // Convert to milliseconds
  } catch (error) {
    console.error(`Error decoding token from ${storageKey}:`, error);
    return null;
  }
};

export const loggerdInUserHasCognitoScope = (scope) => {
  const accessToken = window.localStorage.getItem(COGNITO_ACCESS_TOKEN_KEY);

  if (!hasValidCognitoToken()) return false;

  const decodedToken = jwt_decode(accessToken);
  const scopes = decodedToken?.scope?.split(" ");
  return scopes?.includes(scope) ?? false;
};

export const loggedInUserHasSsciamScope = (scope) => {
  const accessToken = window.localStorage.getItem(SSCIAM_ACCESS_TOKEN_KEY);

  if (!hasValidSsciamToken()) return false;

  const decodedToken = jwt_decode(accessToken);
  const scopes = decodedToken?.scope?.split(" ");
  return scopes?.includes(scope) ?? false;
};

export const doubleAuthEnabled = () => {
  const doubleAuth = localStorage.getItem(DOUBLE_AUTH_KEY);
  return doubleAuth === "true";
};

export const LAST_USED_LOGIN_EMAIL = "lastUsedLoginEmail";

export const clearLocalStorage = () => {
  const itemsToPreserve = [
    { key: "enableSscIam", value: localStorage.getItem("enableSscIam") },
    { key: DOUBLE_AUTH_KEY, value: localStorage.getItem(DOUBLE_AUTH_KEY) },
    { key: LAST_USED_LOGIN_EMAIL, value: localStorage.getItem(LAST_USED_LOGIN_EMAIL) },
  ];

  localStorage.clear();

  itemsToPreserve.forEach(({ key, value }) => {
    if (value) {
      localStorage.setItem(key, value);
    }
  });
};
